export default {"src":"/_next/static/image/public/images/flags/flag_350.785aa303e3f6dc6851a31dc098521d50.svg","height":16,"width":24};